// extracted by mini-css-extract-plugin
export var root = "modal-profile-module--root--385dq";
export var window = "modal-profile-module--window--kuOaX";